export default __webpack_public_path__ + "static/media/clv.a3207c7c.png";